module.exports = __webpack_public_path__ + "static/img/4.82ce5a0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/4.jpeg
// module id = 6/Ft
// module chunks = 1